import { Order } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  order: DbDocument<Order>;
};

export const closeOrder = async ({ order, cafeSlug }: Props) => {
  const batch = createBatch();

  batch.update<Order>(`cafes/${cafeSlug}/orders/${order.id}`, {
    closed: true,
  });

  await batch.commit();
};
